var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"shadow"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"striped":"","hover":"","responsive":""}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }